import React from 'react';
import { formatUsd } from '../../data/countries';
import {
  getSubmissionListerAsk,
  getSubmissionInvestorPrice,
  submissionIsPublicOnSite,
} from '../../utils/submissions';

const ListerPricingBanner = ({ sub, compact }) => {
  const ask = getSubmissionListerAsk(sub);
  const investor = getSubmissionInvestorPrice(sub);
  const live = submissionIsPublicOnSite(sub);
  if (!ask) return null;
  const hasMarkup = investor > ask;
  return (
    <div className={`lister-pricing-banner${compact ? " lister-pricing-banner--compact" : ""}`}>
      <div className="lister-pricing-banner__row">
        <span className="lister-pricing-banner__label">Your ask</span>
        <strong>{formatUsd(ask)}</strong>
      </div>
      {live || hasMarkup ? (
        <div className="lister-pricing-banner__row lister-pricing-banner__row--highlight">
          <span className="lister-pricing-banner__label">On site for investors</span>
          <strong>{formatUsd(investor)}</strong>
        </div>
      ) : null}
      {hasMarkup ? (
        <p className="lister-pricing-banner__note">
          CoOwn may list above your ask for platform services. If you invest in this property, checkout uses the <strong>on-site investor price</strong> ({formatUsd(investor)}), same as other investors.
        </p>
      ) : live ? (
        <p className="lister-pricing-banner__note">
          This matches what investors see on the live listing. If you invest, checkout uses this price.
        </p>
      ) : (
        <p className="lister-pricing-banner__note">
          After approval, CoOwn may set a different on-site price for investors. You will see both here when it applies.
        </p>
      )}
    </div>
  );
};

export default ListerPricingBanner;
